import PropTypes from "prop-types"
import ErrorIcon from "shared/components/icons/error_icon"
import get from "lodash/get"

import "./error_message.scss"

const ERROR_TRANSLATIONS = {
  "Default value can't be blank when the field is required and hidden":
    "Field cannot be blank",
}

export default function ErrorMessageForField({ field, errors }) {
  const untranslatedMessage = get(errors, field)
  const errorMessage =
    ERROR_TRANSLATIONS[untranslatedMessage] || untranslatedMessage

  if (errorMessage?.length > 0) {
    return (
      <span styleName="error-message">
        <ErrorIcon width="24" height="24" />
        {errorMessage}
      </span>
    )
  }

  return null
}

ErrorMessageForField.propTypes = {
  field: PropTypes.string.isRequired,
  errors: PropTypes.object,
}
